import WorkerCard from "./WorkerCard";

export default WorkerCard;
